import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { MenuItem } from "@mui/material";

/**
 * MenuItemComponent
 * Unifies padding, height, font-size, and "inherit" font family.
 * For submenu anchors, ref is forwarded to MUI MenuItem.
 */
const MenuItemComponent = forwardRef(function MenuItemComponent(
  {
    children,
    onClick,
    disabled = false,
    title,
    width = "auto",
    height = 48,
    paddX = 16,
    paddY = 8,
    fontSize = 14,
    color = "#192048",
    sx = {},
    ...rest
  },
  ref,
) {
  return (
    <MenuItem
      ref={ref}
      disabled={disabled}
      onClick={onClick}
      title={title}
      sx={{
        height,
        px: `${paddX}px`,
        py: `${paddY}px`,
        fontSize,
        color,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
        width,
        fontFamily: "inherit",
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MenuItem>
  );
});

MenuItemComponent.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  paddX: PropTypes.number,
  paddY: PropTypes.number,
  fontSize: PropTypes.number,
  color: PropTypes.string,
  sx: PropTypes.object,
};

export default MenuItemComponent;
